import { render } from "./textaPendulum.vue?vue&type=template&id=9497eba8&scoped=true"
import script from "./textaPendulum.vue?vue&type=script&lang=js"
export * from "./textaPendulum.vue?vue&type=script&lang=js"

import "./textaPendulum.vue?vue&type=style&index=0&id=9497eba8&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9497eba8"]])

export default __exports__